"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COMPANY_ITEM = void 0;
exports.DEFAULT_COMPANY_ITEM = {
    name: '',
    id: '',
    url: '',
    userId: '',
    serviceSetting: '',
    serviceStart: '',
    serviceEnd: '',
};
